import type { FC, ReactElement } from 'react';
import React, { Children, cloneElement } from 'react';
import cn from 'classnames';

import type { TList, TSeoTypes } from './models';

export const List: FC<React.PropsWithChildren<TList>> = ({
    children,
    className,
    horizontal = false,
    indentType = 'default',
    itemClassName,
    marginCollapseFirst = false,
    marginCollapseLast = false,
    marker = '—',
    markerColor = 'rgb(239, 49, 36)',
    nowrap = false,
    olRedMarker = false,
    olType,
    styles,
    svgMargin = '0 8px 0 0',
    svgSrc = '',
    svgWidth = 'auto',
    type = 'div',
}) => {
    let ListParent: TSeoTypes;

    let Item: 'li' | 'div';

    switch (type) {
        case 'ul': {
            ListParent = 'ul';
            Item = 'li';
            break;
        }

        case 'ol': {
            ListParent = 'ol';
            Item = 'li';
            break;
        }

        default: {
            ListParent = 'div';
            Item = 'div';
        }
    }

    return (
        <ListParent
            className={
                // eslint-disable-next-line external-classname/specificity
                cn(
                    styles.list,
                    { [styles.orderedList]: olType, [styles.listNowrap]: nowrap },
                    className
                )
            }
            type={olType}
        >
            {Children.toArray(children).map((child, index) => {
                return (
                    <Item
                        // eslint-disable-next-line react/no-array-index-key
                        key={`listItem-${index}`}
                        className={cn(
                            {
                                [styles.listItem]: !horizontal,
                                [styles.horizontalListItem]: horizontal,
                                [styles[`indent-${indentType}`]]: indentType,
                                [styles.marginCollapseFirst]: marginCollapseFirst,
                                [styles.marginCollapseLast]: marginCollapseLast,
                                [styles.orderedListItem]: olType,
                                [styles.redMarker]: olRedMarker,
                            },
                            itemClassName
                        )}
                    >
                        {(marker || svgSrc) && (
                            <div
                                className={styles.marker}
                                style={{
                                    color: markerColor,
                                    margin: svgMargin,
                                }}
                            >
                                {svgSrc ? (
                                    <img
                                        alt="icon"
                                        src={svgSrc}
                                        style={{
                                            width: svgWidth,
                                        }}
                                    />
                                ) : (
                                    marker
                                )}
                            </div>
                        )}

                        {cloneElement(child as ReactElement, {
                            style: { margin: 0, padding: 0 },
                        })}
                    </Item>
                );
            })}
        </ListParent>
    );
};
